<script setup lang="ts">
/**
 * Section 201 — Declaration (± Attestation). 원본(IncorporationDoc) 내용 재현, 인스턴스별 서명자.
 *   name/NRIC 은 인스턴스 스코프(s201_name / s201_nric), company_name/declaration_date 는 공유.
 */
import CddDocVarField from '../cdd/CddDocVarField.vue';

defineProps<{ withAttestation?: boolean }>();
</script>

<template>
  <div class="s201">
    <div class="s201-center">
      <div class="s201-act">SECTION 201 — DECLARATION</div>
      <div class="s201-act sm">
        Declaration by a Person Before Appointment as Director, or by a Promoter Before Incorporation of Corporation —
        <template v-if="withAttestation">With Attestation by Commissioner of Oaths / Notary Public</template>
        <template v-else>Without Attestation</template>
      </div>
    </div>

    <p class="s201-p bold">DECLARATION</p>
    <p class="s201-p">I solemnly and sincerely declare that:</p>
    <ol class="s201-ol">
      <li>I am not an undischarged bankrupt.</li>
      <li>
        I have not been convicted whether within or outside Malaysia of any offence:
        <ol type="a">
          <li>in connection with the promotion, formation or management of a corporation;</li>
          <li>involving fraud or dishonesty punishable on conviction with imprisonment for three months or more; or</li>
          <li>under section 213, 217, 218, 228 or 539, within a period of five years preceding the date of this declaration.</li>
        </ol>
      </li>
      <li>
        I have not been imprisoned for any offence referred to in paragraph 2 within the period of five years
        immediately preceding the date of this declaration.
      </li>
      <li class="dim">* I am an undischarged bankrupt but have been granted leave by the court under section 198(3)(b) to act as a director of …………………… (name of corporation)</li>
      <li class="dim">* I have been granted leave by Court under section 198 to be a director / promoter … (* Strike out whichever is inapplicable)</li>
      <li>
        I hereby consent to act as director of <CddDocVarField field-key="company_name" />.
        I confirm that the facts and information stated in this document are true.
      </li>
    </ol>

    <div class="s201-yours">
      <div>Sign by Director(s)/Promoter(s):</div>
      <div class="s201-sign-line">______________________________</div>
      <div>Name: <CddDocVarField field-key="s201_name" /></div>
      <div>NRIC / Passport No.: <CddDocVarField field-key="s201_nric" /></div>
      <div>Date: <CddDocVarField field-key="declaration_date" /></div>
    </div>

    <div v-if="withAttestation" class="s201-attest">
      <div class="s201-sign-t">Before me:</div>
      <div class="s201-sign-line">______________________________</div>
      <div>Commissioner of Oaths / Notary Public</div>
      <div class="s201-date">Date of Declaration: <CddDocVarField field-key="declaration_date" /></div>
    </div>
  </div>
</template>

<style scoped>
.s201 { color: #111; font-size: 12px; line-height: 1.55; }
.s201-center { text-align: center; margin: 6px 0 14px; }
.s201-act { font-weight: 800; font-size: 14px; letter-spacing: .02em; }
.s201-act.sm { font-weight: 600; font-size: 11.5px; color: #42506a; margin-top: 4px; }
.s201-p { margin: 8px 0; }
.s201-p.bold { font-weight: 800; }
.s201-ol { margin: 8px 0 8px 18px; display: flex; flex-direction: column; gap: 6px; }
.s201-ol ol { margin: 4px 0 4px 18px; }
.s201-ol .dim { color: #8a97b5; }
.s201-yours { margin-top: 22px; display: flex; flex-direction: column; gap: 6px; }
.s201-sign-line { margin: 14px 0 2px; letter-spacing: 1px; }
.s201-attest { margin-top: 26px; display: flex; flex-direction: column; gap: 6px; }
.s201-sign-t { font-weight: 700; }
.s201-date { margin-top: 8px; }
</style>
